import { HubspotWorkflowsRoutes } from './type'

const hubspotWorkflows = `${HubspotWorkflowsRoutes.root}`
const hubspotWorkflowsView = `${hubspotWorkflows}/${HubspotWorkflowsRoutes.view}`

export const HubspotWorkflowsPath = {
  root: hubspotWorkflows,
  view: hubspotWorkflowsView,
}
